module.exports = __webpack_public_path__ + "img/3.ca83f979.jpg";